const API = process.env.REACT_APP_BACKEND_URL || "";

const ytId = (url) => {
  const m = url.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|shorts\/|embed\/|live\/)|youtu\.be\/)([\w-]{11})/);
  return m ? m[1] : null;
};

export const VideoEmbed = ({ url, title }) => {
  if (!url) return null;
  const id = ytId(url);
  return (
    <div className="mt-5 overflow-hidden rounded-2xl border border-white/10 bg-black aspect-video" data-testid="setup-guide-video">
      {id ? (
        <iframe src={`https://www.youtube-nocookie.com/embed/${id}?rel=0`} title={title} className="h-full w-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
      ) : (
        <video src={url.startsWith("/api/") ? `${API}${url}` : url} controls playsInline preload="metadata" className="h-full w-full" />
      )}
    </div>
  );
};
